<template>
  <div>
    <el-table
      :data="clickRateTableList"
      :header-cell-style="{color:'#000000',fontFamily:'Satoshi-Medium !important',fontSize:'14px'}"
      stripe
      border>
      <el-table-column
        width="350"
        label="Contact"
      >
        <template slot-scope="scope">
          <span class="contact">{{scope.row.contact}}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="350"
        label="Store Name"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.storeName" class="store-name" @click="openReport(scope.row)">{{scope.row.storeName}}</span>
          <span v-else class="store-name-na">N/A</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Opens"
      >
        <template slot-scope="scope">
           <span v-if="scope.row.opens" class="opens">{{scope.row.opens}}</span>
           <span v-else class="opens">0</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Clicks"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.clicks" class="clicks">{{scope.row.clicks}}</span>
          <span v-else class="clicks">0</span>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      :currentPage="query.pageNo"
      :total="total"
      :pageSize="query.pageSize"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></Pagination>
  </div>
</template>

<script>
import { getAction } from '../../../api/manage'
import Pagination from '../../components/pagination.vue'
export default {
  components: {
    Pagination
  },
  data() {
    return {
      clickRateTableList: [],
      total: 0,
      query: {
        pageNo: 1,
        pageSize: 20,
        marketingId: '',
        marketingBatch: '',
        type: 'click'
      }
    }
  },
  methods: {
    openReport(row) {
      var encrypt = btoa(row.storeId)
      const routeUrl = this.$router.resolve(`/menu/Explore?isReport=1&userId=${row.userId}&storeId=${encrypt}`)
      window.open(routeUrl.href, '_blank')
    },
    init(marketingId, marketingBatch) {
      this.query.marketingId = marketingId
      this.query.marketingBatch = marketingBatch
      this.query.pageNo = 1
      this.query.pageSize = 20
      this.loadData()
    },
    loadData() {
      // 判断参数
      if (this.query.marketingId === undefined || !this.query.marketingId || this.query.marketingBatch === undefined || !this.query.marketingBatch) {
        this.$message.error('缺少参数')
        return
      }
      getAction('/marketing/activity/api/v0.2/detail/list', this.query).then(response => {
        if (response.success) {
          if (response.result) {
            this.clickRateTableList = response.result.records
            this.total = response.result.total
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    handleSizeChange(pageSize) {
      this.query.pageSize = pageSize
      this.query.pageNo = 1
      this.loadData()
    },
    handleCurrentChange(currentPage) {
      this.query.pageNo = currentPage
      this.loadData()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-table--border .el-table__cell{
  border-right:none
}
.contact,.store-name,.store-name-na,.opens,.clicks{
  color: #000000;
}
.store-name{
  cursor: pointer;
  text-decoration: underline;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏溢出部分 */
  text-overflow: ellipsis; /* 显示省略号 */
}
</style>



// WEBPACK FOOTER //
// src/pages/store-based-marketing/store-based-marketing-detail/click-rate.vue